import React from 'react';
import { Box, List, ListItemText, Typography, ListItemButton, Card } from '@mui/material';
import BasePopover from './base-popover.component';
import i18n from 'i18next';
import { Resources } from '../../i18n';
import { userData } from '../../page/app.page';

export default function TranslatePopover(props: {
    anchorEl: HTMLElement | null;
    onClose: () => void;
}) {
    const { anchorEl, onClose } = props;
    const languageOption = [
        { value: 'CN', label: '简体中文' },
        { value: 'IT', label: 'Italia' },
        { value: 'EN', label: 'English' },
        { value: 'SP', label: 'España' }
    ];
    const [s, sets] = React.useState(i18n.language);

    return (
        <BasePopover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            id='translate-popover'
        >
            <Card >
                <List >
                    {languageOption.map((item) => {
                        return (
                            <ListItemButton
                                key={item.value}
                                disableGutters={false}
                                selected={item.value === s}
                                onClick={() => {
                                    requestAnimationFrame(() => {
                                        // i18n.changeLanguage(item.value);
                                        userData.updateLanguage(item.value as Resources);
                                        sets(item.value);
                                    })
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Box className='FCC'>
                                            <Typography >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    }
                                    color='primary'
                                />
                            </ListItemButton>
                        )
                    })}
                </List>
            </Card>
        </BasePopover>
    )
}